/**
 * LeasesPanel — file PMS baux récents (60 derniers jours).
 * Batch #14.154 — extracted from AdminPmsQueuePage.jsx during refactor.
 */
import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { FileSignature, Loader2, Trash2 } from "lucide-react";
import { toast } from "@/lib/toast";
import { API, authH } from "./_shared";

export default function LeasesPanel() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deletingId, setDeletingId] = useState(null);

  const fetchItems = useCallback(async () => {
    setLoading(true);
    try {
      const r = await axios.get(`${API}/admin/pms/leases?days=60`, { headers: authH() });
      setItems(r.data?.items || []);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erreur");
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => { fetchItems(); }, [fetchItems]);

  const handleDelete = async (L) => {
    if (!window.confirm(
      `Supprimer définitivement le bail Apt ${L._unit_label || "?"} (${L._master_name}) ?\n\n` +
      `Cette action est IRRÉVERSIBLE. N'affecte pas l'unité ni les locataires.`
    )) return;
    setDeletingId(L.id);
    try {
      await axios.delete(`${API}/admin/pms/leases/${L.id}`, { headers: authH() });
      toast.success("Bail supprimé");
      fetchItems();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Échec de suppression");
    } finally {
      setDeletingId(null);
    }
  };

  return (
    <>
      <div className="px-5 py-3 border-b bg-slate-50">
        <div className="flex items-center gap-2">
          <FileSignature className="w-4 h-4 text-blue-600" />
          <h2 className="font-semibold text-slate-800 text-sm">Baux créés récemment (60 derniers jours)</h2>
        </div>
      </div>
      <div className="p-3">
        {loading ? (
          <div className="text-center py-10"><Loader2 className="w-6 h-6 animate-spin text-slate-300 mx-auto" /></div>
        ) : items.length === 0 ? (
          <div className="text-center py-10 text-sm text-slate-400 italic">Aucun bail récent</div>
        ) : (
          <div className="space-y-1.5">
            {items.map((L) => (
              <div key={L.id} className="flex items-center gap-3 p-3 rounded-lg border border-slate-200" data-testid={`admin-lease-row-${L.id}`}>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="font-semibold text-slate-800 text-sm">Apt {L._unit_label || "?"}</span>
                    <span className="text-[11px] text-slate-500">· {L.start_date} → {L.end_date}</span>
                    {L.rent_monthly && (
                      <span className="text-[11px] font-mono px-1.5 py-0.5 rounded bg-emerald-50 text-emerald-700">{L.rent_monthly.toLocaleString("fr-CA")} $/mois</span>
                    )}
                  </div>
                  <div className="text-[11px] text-slate-500 truncate mt-0.5">
                    <b>{L._master_name}</b> · Locataires : {(L._tenant_names || []).join(", ") || "—"}
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() => handleDelete(L)}
                  disabled={deletingId === L.id}
                  className="text-rose-500 hover:text-rose-700 hover:bg-rose-50 p-1.5 rounded disabled:opacity-50"
                  data-testid={`admin-lease-delete-${L.id}`}
                  title="Supprimer définitivement"
                >
                  {deletingId === L.id ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Trash2 className="w-3.5 h-3.5" />}
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}
